
export function loadOptinsForEdit () {
    this.optinsForEdit = this.env.getPageInfo('/admin/marketing/optins/edit/');
}

export function saveOptinsForEdits () {
    this.env.setPageInfo('/admin/marketing/optins/edit/', this.optinsForEdit);
}
